import { Button, styled, useTheme } from '@mui/material';
import { CSSProperties, FC } from 'react';
import { SelectItem } from '../../types';
import { ReactComponent as CheckIcon } from '../../assets/icons/checked-blue.svg';

type Props = {
  options: SelectItem[];
  selectedItem: SelectItem | null;
  onSelect: (item: SelectItem) => void;
  noCheckIcon?: boolean;
  containerStyles?: CSSProperties;
  buttonStyles?: CSSProperties;
};

const Wrapper = styled('div')`
  display: flex;
  gap: 12px;
`;

const ButtonChip = styled('div')<{ isSelected?: boolean }>`
  .MuiButtonBase-root.MuiButton-outlined {
    border: 1px solid
      ${({ theme, isSelected }) =>
        isSelected ? theme.colors.accent[50] : theme.colors.primary[30]};
    color: ${({ theme, isSelected }) =>
      isSelected ? theme.colors.accent[50] : theme.colors.primary[90]};
  }
  .MuiButtonBase-root.MuiButton-outlined:hover {
    border: 1px solid ${({ theme }) => theme.colors.accent[50]};
    color: ${({ theme }) => theme.colors.accent[50]};
    background-color: ${({ theme, isSelected }) =>
      isSelected ? theme.colors.accent[5] : 'transparent'};
  }
`;

export const ChipsSelector: FC<Props> = ({
  options,
  selectedItem,
  onSelect,
  noCheckIcon,
  containerStyles,
  buttonStyles,
}) => {
  const { accent } = useTheme().colors;
  return (
    <Wrapper style={containerStyles}>
      {options.map((o) => (
        <ButtonChip key={o.id} isSelected={o.id === selectedItem?.id}>
          <Button
            startIcon={o.id === selectedItem?.id && !noCheckIcon ? <CheckIcon /> : null}
            variant='outlined'
            onClick={() => onSelect(o)}
            style={{
              backgroundColor: o.id === selectedItem?.id ? accent[5] : '#fff',
              ...buttonStyles,
            }}
          >
            {o.value}
          </Button>
        </ButtonChip>
      ))}
    </Wrapper>
  );
};
